<div class="voucher-code" role="region" aria-labelledby="voucher-heading">
  <div class="voucher-graphics">
    <img class="voucher-graphics-img" [src]="'banners/voucher.svg' | contentAssetImage" alt="" aria-hidden="true" />
  </div>

  <div class="voucher-content">
    <!--Voucher info-->
    <div class="voucher-info">
      <div class="voucher-title" id="voucher-heading">{{ 'voucher.label' | translate }}</div>
      <div class="voucher-instructions">{{ 'voucher.instructions' | translate }}</div>
    </div>

    <!--Input group-->
    <div class="voucher-input-group">
      <input
        id="voucher-input"
        type="text"
        class="voucher-field"
        [(ngModel)]="voucherCode"
        [placeholder]="'voucher.placeholder' | translate : { fgbdefault: 'Enter Code' }"
        [attr.aria-invalid]="isInvalid() || null"
        aria-describedby="voucher-status"
        autocomplete="off"
        spellcheck="false"
        (keyup.enter)="redeemVoucher()"
      />

      <button
        class="btn voucher-submit"
        type="button"
        (click)="redeemVoucher()"
        [disabled]="isLoading()"
        [attr.aria-busy]="isLoading() || null"
      >
        {{ 'voucher.apply' | translate : { fgbdefault: 'Apply' } }}
      </button>

      <!--Accessibility -->
      <div id="voucher-status" class="sr-only" aria-live="polite" aria-atomic="true">
        @if (status()) {
          {{ statusKey() | translate : { fgbdefault: statusDefault() } }}
        }
      </div>
    </div>
  </div>


  @if (status()) {
    <div class="status-pill" [ngClass]="'status-pill-' + variantType()" role="status">
      <i class="status-icon material-icons" aria-hidden="true">{{ statusIcon() }}</i>
      <span>{{ statusKey() | translate : { fgbdefault: statusDefault() } }}</span>
    </div>
  }
</div>
